// extracted by mini-css-extract-plugin
export default {"logo":"GreenhouseCard_logo__AlnEf"};